<template>
  <v-container class="fondo_login fill-height"  fluid>
    <v-row  class="d-flex justify-center">       
      <v-col  sm=12 md="4" class="d-flex flex-column align-center" >
        <div id="google_btn"></div>                    
      </v-col>
      <hr class="divisor-medio my-4 " >    

    </v-row>
    <v-row class="d-flex justify-center">
      <v-col :style="{ 'max-width': `${ancho_boton}px`}" class="d-flex justify-center">   
          <v-btn :style="{ 'width': `${ancho_boton}px`, 'height': '40px', 'font-family': 'Google Sans,arial,sans-serif', 'text-transform': 'none' }"
            block  
            class="white--text" 
            color="#58C4B5" 
            @click="onRegistrarse()">         
            Regístrate con tu correo electrónico
          </v-btn>           
        <br>
        <br>
      </v-col>
    </v-row>   

    <v-row class="d-flex justify-center  pb-0 ">

      <hr class="divisor  " >    
      <div class="mr-2 blue-grey--text subtitle-1 pb-0 pt-2  mt-6">¿Ya tienes cuenta?</div>
      <div 
        class="btn-registrate subtitle-1 pb-0 pt-2  mt-6"
        @click="$router.push('/home')"
      > Inicia sesión</div>
    </v-row>
          
  </v-container>
</template>

<script>
import Vista from "@/objetos/vista";
import Usuario from "@/objetos/usuario";
import jwt_decode from 'jwt-decode';
import process_env from '@/config/dev.env.js';

/**
 * Esta funcion carga asincronamente el SDK de FB en la app.
 * Fuente: https://developers.facebook.com/docs/facebook-login/web
 * 4228201323886088 - QA
 * 1916541518553574 - Prod
 */
// eslint-disable-next-line no-undef
window.fbAsyncInit = function() {    
  //eslint-disable-next-line no-undef
    FB.init({
      appId      : '1916541518553574',
      cookie     : true, // enable cookies to allow the server to access the session
      xfbml      : true,
      version    : 'v13.0'
    });
    //eslint-disable-next-line no-undef
    FB.AppEvents.logPageView(); 
  };
  (function(d, s, id){
     var js, fjs = d.getElementsByTagName(s)[0];
     if (d.getElementById(id)) {return;}
     js = d.createElement(s); js.id = id;
     js.src = "https://connect.facebook.net/en_US/sdk.js";
     fjs.parentNode.insertBefore(js, fjs);
   }(document, 'script', 'facebook-jssdk'));

export default {
  data: () => ({
    mostrar_error: false,
    mensaje_error: null,
    vista: Vista,
    /*
      Se declaran los parametros que se pretenden que regrese la API
       de facebook en caso de logeo existoso
    */
    mostrar: false,
    pagina: null,
    registrarse: 'registrarse',
    loader: null,
    loader_login: false,
    imagen_fondo: "",
    process_env: process_env
  }),
  watch: {
    $route(to) {
      this.pagina = to.name;
    },
    loader() {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 3000)

      this.loader = null
    },
  },
  computed:{
    ancho_boton () {
      let ancho;
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': 
            if(this.$vuetify.breakpoint.width < 340) ancho = '250'
            else ancho = '300'
          break;
          case 'sm': ancho ='400'
          break;
          case 'md': ancho = '400'
          break
          case 'lg': ancho = '400'
          break;
          case 'xl': ancho = '400'
          break;
        }
      return ancho
    }
  },
  created(){                
      Usuario.google = window.google
      Usuario.google.accounts.id.initialize({
          client_id: this.process_env.CLIENT_ID,
          callback: this.handleCredentialResponse,
          itp_support: false      
      });             
  },
  mounted() {
    this.vista.nombre = "/home";
     //El script de google se cargo a public https://accounts.google.com/gsi/client
    /**
     * The Auth2 parameters, as seen on
     * En esta sección se declara el client id que da google solo se debe de cargar una vez 
     * ya que esta nueva versiòn google no permite cargarlo dos veces 
     * https://developers.google.com/identity/gsi/web/reference/js-reference?hl=es-419
     * As the very least, a valid client_id must present.
     * @type {Object}
     */    
    const parent = document.getElementById('google_btn');          
    Usuario.google.accounts.id.renderButton(parent, {locale:"es",logo_alignment: "center",size:"large",text: "signup_with",width: this.ancho_boton ? Number(this.ancho_boton) : 400});
    
    this.$root.$off('enviar_datos');
    Usuario.codigo_valido = false;
  },
  updated(){
    const parent = document.getElementById('google_btn');
    Usuario.google.accounts.id.renderButton(parent, {locale:"es",logo_alignment: "center",size:"large",text: "signin_with",width: this.ancho_boton ? Number(this.ancho_boton) : 400});
  },
  methods: {
    onRegistrarse(){
      Usuario.login_social = false;
      Usuario.clear_form = true;
      this.$router.push('/registrarse');
    },
    handleCredentialResponse(response){
      const responsePayload = jwt_decode(response.credential);
        Usuario.nombre = responsePayload.name;
        Usuario.nombre_vista = responsePayload.name;
        Usuario.correo = responsePayload.email;
        Usuario.login_social = true;  
        Usuario.telefono = "";      
        Usuario.rut = "";
        Usuario.direccion = "";    
        this.$router.push("/registrarse")  
    },
    onSignInSuccess(googleUser) {
      const profile = googleUser.getBasicProfile(); // etc etc
      Usuario.nombre = profile.getName();
      Usuario.nombre_vista = profile.getName();
      Usuario.correo = profile.getEmail();
      Usuario.login_social = true;  
      Usuario.telefono = "";      
      Usuario.rut = "";
      Usuario.direccion = "";    
      this.$router.push("/registrarse")
  
    },
    /**Facebook
     * Está función se manda a llamar cuando a habido error al logearse 
    */    
    onSignInError(error) {
      // `error` contains any error occurred.
      console.error("onSignInErrorGoogle", error);
    },
    /**Facebook
     * Está función se manda a llamar cuando se ha logeado a FB con éxito
    */
    onSignInSuccess_fb(response) {
      // Tomar de aqui el tiempo de sesion response.data_access_expiration_time: 1601845791
      // response.expiresIn: 5107217
      // eslint-disable-next-line no-undef
      FB.api("/me", {
        fields: "id,name,email"
      }, facebookUser => {
        if (response.status == "connected") {          
          Usuario.nombre = facebookUser.name;
          Usuario.nombre_vista = facebookUser.name;
          Usuario.correo = facebookUser.email;
          Usuario.id_facebook = facebookUser.id
          Usuario.login_social = true;
          Usuario.telefono = "";      
          Usuario.rut = "";
          Usuario.direccion = "";    
          if( Usuario.correo) this.$router.push("/registrarse")
        }
      });
    },
    onSignInError_fb(error) {
      console.error("onSignInError_fb: ", error);
    },
    cambiar_vista(nombre) {
      let ruta = `/${nombre.toLowerCase()}`
      if (this.pagina != nombre)
        this.$router.push(ruta)
    }
  }
};
</script>

<style >
.fondo_login{
  background: #F5F5F5 0% 0% no-repeat padding-box;
  background-size: 100% 100% !important;
  align-content: center;
}

#google_btn {
  padding-left: 0;
  padding-bottom: 20px;
}

.v-btn-signin{
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #dadce0 !important;
  text-transform: none;
  height: 40px !important;
  padding: 0 !important;
  letter-spacing: 0.25px;
  background: #ffffff;
  font-weight: 600;
  font-family: Helvetica, Helvetica, sans-serif;
  color: #0e0a0aa3;
  font-size: 13px;
  text-align: center;
  cursor: pointer;
}

.v-btn-signin:hover {
  background: rgba(70, 137, 243, 0.1);
  border: 1px solid rgb(66,133,244, 0.2) !important;
}

.signin-button{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
}
</style>